import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { ImageShowActionComponent } from './imageShow';

declare let $: any;
declare let Swal:any;

@Component({
    selector : 'imageShow-action-second',
    templateUrl:'imageShowActionSecond.html'
})
export class ImageShowActionSecondComponent  extends ImageShowActionComponent{

  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
  }
  public level=2;
  public ngOnInit(): any {


  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/imageShowActionSecond.ts